import {
  SET_BOOKED_DININGS,
  SET_BOOKED_ENTERTAINMENTS,
  SET_AVAILABLE_ENTERTAINMENTS,
} from '../constants/bookedEvents';

export const setBookedDinings = ({ bookedBreakfast, bookedDinner }) => ({
  type: SET_BOOKED_DININGS,
  bookedBreakfast,
  bookedDinner,
});

export const setBookedEntertainments = (bookedEntertainments, latestActivityBookingDate) => ({
  type: SET_BOOKED_ENTERTAINMENTS,
  bookedEntertainments,
  latestActivityBookingDate,
});

export const setAvailableEntertainments = (
  availableEntertainments,
  arrivalTime,
  latestBookingDateEndTime,
  departureTime,
  latestActivityBookingDate,
  isDaBooking,
  dineAroundBreakfastCategory,
  dineAroundDinnerCategory,
) => ({
  type: SET_AVAILABLE_ENTERTAINMENTS,
  availableEntertainments,
  arrivalTime,
  latestBookingDateEndTime,
  departureTime,
  latestActivityBookingDate,
  isDaBooking,
  dineAroundBreakfastCategory,
  dineAroundDinnerCategory,
});
